import all from "./modules/allApi";

/**
 * 当前目录下的 modules 文件夹中，存放所有的业务模块所相关的 ajax api 路径。
 * site 与 biz1 为两个示例业务模块。
 *
 * ajax 调用示例：
 * _api.site.getUserInfo({
 *    // params...
 * }).then(result=>{
 *    // 回调
 * })
 *
 * 注意：
 * 1. 导出的模块名字必须与文件名一致。
 * 2. _api 为全局变量，直接使用，不需要显式引入。
 */
export default {
  all
};
